import React from "react";
const TestimonialIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/testimonials.svg";

const GoogleIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/google.svg";

export default function TestimonialCard({ content, name, username, image }) {
  return (
    <div className="portfoliotestimonialcard">
      <img
        src={TestimonialIcon}
        alt="Testimonial Icon"
        className="toptestimonialicon"
      />
      <p className="portfoliotestimonialcardcontent">{content}</p>
      <div className="portfoliotestimonialcardbottom">
        {/* <img src={image} alt="User Image" /> */}
        <div className="portfoliotestimonialcardbottomright">
          <h5>{name}</h5>
          <div className="portfoliotestimonialcardbottomrightuser">
            <h6>@{username}</h6>
            {/* <p> - verified from</p> <img src={GoogleIcon} alt="Google" /> */}
          </div>
        </div>
      </div>
    </div>
  );
}
